const UPDATE_MANIFEST = `mutation skipTask($input: [BatchUpdateAssignmentManifestInput!]!){
  batchUpdateAssignmentManifest(input: $input){
    manifest{
      activityType
      locale
      status
    }
  }
}
`;

export default UPDATE_MANIFEST;
